import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-advanced-setting',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdvancedSettingComponent),
      multi: true,
    },
  ],
  templateUrl: './advanced-setting.component.html',
  standalone: false,
})
export class AdvancedSettingComponent implements ControlValueAccessor {
  @Input() settingName: string;
  @Input() value: string;
  private onChange: Function;
  private onTouched: Function;

  constructor() {
    this.onChange = (_: Function) => {};
    this.onTouched = () => {};
  }

  setValue(event: MatRadioChange) {
    this.value = (event as MatRadioChange).value as string;
    this.onChange(this.value);
    this.onTouched();
  }

  writeValue(obj: string): void {
    this.value = obj;
  }

  registerOnChange(fn: Function): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onTouched = fn;
  }
}
